// pagina ubicaciones de cliente (mapa, pines y selector de cliente list)

import React, { useState } from 'react';
import SiteMap from '../components/SiteMap';
import SiteList from '../components/SiteList';
import ClientSelector from '../components/ClientSelector';
import { Box, Typography } from '@mui/material';

export default function Sites() {
  
  const [selectedClientId, setSelectedClientId] = useState(null);

  return (
    <section>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Ubicación de Cliente</Typography>
      </Box>
      <SiteMap clientId={selectedClientId} />
      <br />
      <ClientSelector onSelectClientId={setSelectedClientId} />
      <SiteList clientId={selectedClientId} disableActions={true} />
    </section>
  );
}
